import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { UtilityBarComponent } from './utility-bar/component';
import { MenuBarComponent } from './menu-bar/component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { AcademicsComponent } from './academics/academics.component';
import { BeyondAcademicsComponent } from './beyond-academics/beyond-academics.component';
import { ExtraCurricularActivitiesComponent } from './beyond-academics/extra-curricular-activities/component';
import { LiteraryCulturalComponent } from './beyond-academics/extra-curricular-activities/literary-cultural/component';
import { SportsComponent } from './beyond-academics/extra-curricular-activities/sports/component';
import { KannadaSanghaComponent } from './beyond-academics/extra-curricular-activities/kannada-sangha/component';
import { ScienceClubComponent } from './beyond-academics/extra-curricular-activities/science-club/component';
import { CommerceClubComponent } from './beyond-academics/extra-curricular-activities/commerce-club/component';
import { PhotographyClubComponent } from './beyond-academics/extra-curricular-activities/photography-club/component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { ResourcesComponent } from './resources/resources.component';
import { StudentsComponent } from './students/students.component';
import { AluminiComponent } from './alumini/alumini.component';
// import { SidebarEffects } from './sidebar/store/sidebar-effects';
import { ContactComponent } from './contact/contact.component';
import { NewsComponent } from './news/news.component';
import { AchievementsComponent } from './achievements/achievements.component';
import { ManagementTeamComponent } from './about/management-team/management-team.component';
import { FacultyComponent } from './about/faculty/faculty.component';
import { FoundersComponent } from './about/founders/founders.component';
import { PrincipalsComponent } from './about/principals/principals.component';
import { PrincipalDeskComponent } from './about/principal-desk/principal-desk.component';
import { AcademicStaffComponent } from './about/academic-staff/academic-staff.component';
import { HistoryComponent } from './about/history/history.component';
import { TestimonialsComponent } from './about/testimonials/component'; 
import { CoursesOfferedComponent } from './academics/courses-offered/courses.component';
import { DisciplineConductComponent } from './academics/discipline-conduct/discipline-conduct.component';
import { CalendarComponent } from './academics/calendar/calendar.component';
import { VisionMissionComponent } from './about/vision-mission/vision-mission.component';
import { BestPracticesComponent } from './about/best-practices/component';
import { AchievementsAcademicsComponent } from './achievements/achievements-academics/achievements-academics.component';
import { AchievementsNonAcademicsComponent } from './achievements/non-academics/component';
import { ResultAnalysisComponent } from './achievements/result-analysis/component';
import { TalentHubComponent } from './about/best-practices/talent-hub/component';
import { AlumniComponent } from './beyond-academics/alumni/component';
import { CareerGuidanceComponent } from './about/best-practices/career-guidance/component';
import { ValueAddedProgramComponent } from './about/best-practices/value-added-programme/component';
import { VisitsComponent } from './visits/component';
import { JNCASRComponent } from './visits/academic/JNCASR/component';
import { RRIComponent } from './visits/academic/RRI/component';
import { KIMSComponent } from './visits/academic/KIMS/component';
import { KMFComponent } from './visits/academic/KMF/component';
import { CeNSComponent } from './visits/academic/CeNS/component';
import { UNIBICComponent } from './visits/academic/UNIBIC/component';
import { IIScComponent } from './visits/academic/IISc/component';
import { GKVKComponent } from './visits/academic/GKVK/component';
import { SojournStudentsComponent } from './visits/sojourn/students/component';
import { SojournStaffComponent } from './visits/sojourn/staff/component';
import { ResultComponent } from './result/component';
import { AdmissionsComponent } from './admissions/component';
import { AdmissionProcessComponent } from './admissions/process/component';
import { AdmissionFAQComponent } from './admissions/faq/component'; 
import { AdmissionApplicationComponent } from './admissions/application/component';
import { GalleryComponent } from './gallery/component';
import { MentoringCounsellingComponent } from './about/best-practices/mentoring/component';
import { ParentTeacherMeetComponent } from './about/best-practices/parent-teacher-meet/component';
import { ValueAddedProgramStudentsComponent } from './about/best-practices/value-added-programme/students/component';
import { ValueAddedProgramStaffComponent } from './about/best-practices/value-added-programme/staff/component';

import { CETNEETComponent } from './home/cet-neet/component';
import { IITSchoolConnectComponent } from './home/IIT-School-Connect/component';
import { TallyComponent } from './home/tally/component';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'academics', component: AcademicsComponent },
  { path: 'beyond-academics', component: BeyondAcademicsComponent },
  { path: 'beyond-academics/extra-curricular-activities', component: ExtraCurricularActivitiesComponent },
  { path: 'beyond-academics/extra-curricular-activities/literary-cultural', component: LiteraryCulturalComponent },
  { path: 'beyond-academics/extra-curricular-activities/sports', component: SportsComponent },
  { path: 'beyond-academics/extra-curricular-activities/kannada-sangha', component: KannadaSanghaComponent },
  { path: 'beyond-academics/extra-curricular-activities/science-club', component: ScienceClubComponent },
  { path: 'beyond-academics/extra-curricular-activities/commerce-club', component: CommerceClubComponent },
  { path: 'beyond-academics/extra-curricular-activities/photo-club', component: PhotographyClubComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'alumini', component: AluminiComponent },
  { path: 'photo-gallery', component: PhotoGalleryComponent },
  { path: "resources", component: ResourcesComponent },
  { path: "students", component: StudentsComponent },
  { path: "news", component: NewsComponent },
  { path: "achievements", component: AchievementsComponent },
  { path: "about/management-team", component: ManagementTeamComponent },
  { path: "about/history", component: HistoryComponent },
  { path: "about/faculty", component: FacultyComponent },
  { path: "about/founders", component: FoundersComponent },
  { path: "about/principals", component: PrincipalsComponent },
  { path: "about/principal-desk", component: PrincipalDeskComponent },
  { path: "about/academic-staff", component: AcademicStaffComponent },
  { path: "about/best-practices", component: BestPracticesComponent },
  { path: "about/testimonials", component: TestimonialsComponent },
  { path: "academics/courses-offered", component: CoursesOfferedComponent },
  { path: "academics/discipline-conduct", component: DisciplineConductComponent },
  { path: "academics/calendar", component: CalendarComponent },
  { path: "about/vision-mission", component: VisionMissionComponent },
  { path: "about/best-practices/mentoring-counselling", component: MentoringCounsellingComponent },
  { path: "about/best-practices/parent-teacher-meet", component: ParentTeacherMeetComponent },
  { path: "achievements/achievements-academics", component: AchievementsAcademicsComponent },
  { path: "achievements/achievements-non-academics", component: AchievementsNonAcademicsComponent },
  { path: "achievements/result-analysis", component: ResultAnalysisComponent },
  { path: "about/best-practices/talent-hub", component: TalentHubComponent},
  { path: "beyond-academics/alumni", component: AlumniComponent },
  { path: "about/best-practices/career-guidance", component: CareerGuidanceComponent },
  { path: "about/best-practices/value-added-programme", component: ValueAddedProgramComponent },
  { path: "about/best-practices/value-added-programme-students", component: ValueAddedProgramStudentsComponent },
  { path: "about/best-practices/value-added-programme-staff", component: ValueAddedProgramStaffComponent },
  { path: "visits", component: VisitsComponent },
  { path: "visits/academics/jncasr", component: JNCASRComponent },
  { path: "visits/academics/cens", component: CeNSComponent },
  { path: "visits/academics/gkvk", component: GKVKComponent },
  { path: "visits/academics/iisc", component: IIScComponent },
  { path: "visits/academics/rri", component: RRIComponent },
  { path: "visits/academics/kmf", component: KMFComponent },
  { path: "visits/academics/kims", component: KIMSComponent },
  { path: "visits/academics/unibic", component: UNIBICComponent },
  { path: "visits/sojourn/students", component: SojournStudentsComponent },
  { path: "visits/sojourn/staff", component: SojournStaffComponent },
  { path: "result", component: ResultComponent },
  { path: "admissions", component: AdmissionsComponent },
  { path: "admissions/process", component: AdmissionProcessComponent },
  { path: "admissions/faq", component: AdmissionFAQComponent },
  { path: "admissions/application", component: AdmissionApplicationComponent },
  { path: "gallery", component: GalleryComponent },
  { path: "cet-neet", component: CETNEETComponent },
  { path: "iit-connect", component: IITSchoolConnectComponent },
  { path: "tally", component: TallyComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    AcademicsComponent,
    BeyondAcademicsComponent,
    ExtraCurricularActivitiesComponent,
    LiteraryCulturalComponent,
    KannadaSanghaComponent,
    ScienceClubComponent,
    CommerceClubComponent,
    PhotographyClubComponent,
    PhotoGalleryComponent,
    ResourcesComponent,
    StudentsComponent,
    AluminiComponent,
    ContactComponent,
    NewsComponent,
    AchievementsComponent,
    ManagementTeamComponent,
    FacultyComponent,
    FoundersComponent,
    HistoryComponent,
    PrincipalsComponent,
    PrincipalDeskComponent,
    AcademicStaffComponent,
    CoursesOfferedComponent,
    DisciplineConductComponent,
    CalendarComponent,
    SportsComponent,
    VisionMissionComponent,
    BestPracticesComponent,
    MentoringCounsellingComponent,
    ParentTeacherMeetComponent,
    TestimonialsComponent,
    AchievementsAcademicsComponent,
    AchievementsNonAcademicsComponent,
    ResultAnalysisComponent,
    TalentHubComponent,
    CareerGuidanceComponent,
    ValueAddedProgramComponent,
    AlumniComponent,
    VisitsComponent,
    JNCASRComponent,
    IIScComponent,
    GKVKComponent,
    KIMSComponent,
    KMFComponent,
    UNIBICComponent,
    CeNSComponent,
    RRIComponent,
    SojournStudentsComponent,
    SojournStaffComponent,
    ResultComponent,
    AdmissionsComponent,
    AdmissionProcessComponent,
    AdmissionFAQComponent,
    AdmissionApplicationComponent,
    AdmissionApplicationComponent,
    GalleryComponent,
    UtilityBarComponent,
    MenuBarComponent,
    ValueAddedProgramStudentsComponent,
    ValueAddedProgramStaffComponent,
    TallyComponent,
    IITSchoolConnectComponent,
    CETNEETComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    // EffectsModule.forRoot([SidebarEffects])
  ],
  providers: [


  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
